import Link from "next/link";
import styles from './PostalEntry.module.css';

const PostalEntry = () => {
    return (
      <Link
        href={'/alternative-entry-method'}
        className={styles.postalEntryContainer}>
        Or... enter by post
                  
      </Link>
    );
}

export default PostalEntry;